import React from 'react';
import { useParams } from 'react-router-dom';
import './auto-fill-new-student-form.css'
import axios from 'axios';
import { baseUrl } from '../../assets/Animations';
import {Controller, useFieldArray, useForm} from 'react-hook-form';
import { InstrumentChip } from './InstrumentChip/InstrumentChip';
import { PrimaryButtonLarge } from '../../DanitComponents/Buttons/PrimaryButton';
import FormStepper from './FormStepper/FormStepper';
import {HiX} from 'react-icons/hi'
import ConfirmationPage from './ConfirmationPage/ConfirmationPage';
import { theInputsPage1 } from './generateInputs';
import { DayOfTheWeekCheckboxSet } from './DayOfTheWeekCheckboxSet';
import InputMask from 'react-input-mask'
import { ChevronDoubleDownIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { getRequestHeaders } from '../../api';
const { eachDayOfInterval, startOfWeek, endOfWeek, format, isValid, sub } = require('date-fns');

let defaultFormValues = {
    students: [{
        studentId: Math.random().toString(16).slice(2),
        studentName: '',
        dob: '',
        experienceLevel: '',
        instrumentList: []
    }],
    primaryEmail: '',
    primaryParentName: '',
    familyName: '',
    primaryCellphone: '',
    addressLine1: '',
    city: '',
    state: '',
    zipcode: ''
}


const AutoFillNewStudentForm = ({subdomainName, hasFamilyId}) => {
    const [family, setFamily] = React.useState({})
    const [instruments, setInstruments] = React.useState([])
    const [schools, setSchools] = React.useState([])
    const [school, setSchool] = React.useState({})
    const [page, setPage] = React.useState(1)
    const { register, handleSubmit, reset, watch, formState, setValue, getValues, control } = useForm({mode: 'onBlur', defaultValues: defaultFormValues});
    const {fields, append, remove, update, replace} = useFieldArray({ control, name: 'students'})
    const [loading, setLoading] = React.useState(true)
    const [youMustAddAStudentWarning, setYouMustAddAStudentWarning] = React.useState(false)
    const [runAnimation, setRunAnimation] = React.useState(false)
    const [currentAnimationSettings, setCurrentAnimationSettings] = React.useState({})
    const [openDate, setOpenDate] = React.useState('')
    const [weeklyAvailability, setWeeklyAvailability] = React.useState({
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: []
    })
    const familyRef = React.useRef(family)
    const currentDate = new Date();
    const startOfWeekDate = startOfWeek(currentDate);
    const endOfWeekDate = endOfWeek(currentDate);
    const daysOfWeek = eachDayOfInterval({ start: startOfWeekDate, end: endOfWeekDate });

    //get the params from the url
    //scratch id 4160b6e0cfbaf
    const { familyId } = useParams();


    const fetchAllData = async () => {
        try {
            const headers = getRequestHeaders(); 
    
            const [instResponse, schoolsResponse, familyResponse] = await Promise.all([
              axios.get(`${baseUrl}/inst`, { headers }),
              axios.get(`${baseUrl}/schools`, { headers }),
              axios.get(`${baseUrl}/school-management/${familyId}`, { headers })
            ]);
          const sortedInstruments = instResponse.data.sort((a, b) => a.name.localeCompare(b.name));

          if(familyResponse.data) {
            setFamily(familyResponse.data);
            initializeTheForm(familyResponse.data)
            familyRef.current = familyResponse.data
          } else {
            initializeEmptyForm()
            setLoading(false)
          }

          setInstruments(sortedInstruments);
          setSchools(schoolsResponse.data);

        } catch (error) {
          console.error(error);
        }
      };

      const fetchOnlySchoolsAndInstruments = async () => {
        setLoading(false)
        const [instResponse, schoolsResponse] = await Promise.all([
            axios.get(`${baseUrl}/inst`),
            axios.get(`${baseUrl}/schools`)
            ]);
            const sortedInstruments = instResponse.data.sort((a, b) => a.name.localeCompare(b.name));
            setInstruments(sortedInstruments);
            setSchools(schoolsResponse.data);

      }



    React.useEffect(() => {
        hasFamilyId ? fetchAllData() : fetchOnlySchoolsAndInstruments()
    }, [familyId]);

    React.useEffect(() => {
        let subdomain = getSubdomain();
        if(schools.length > 0 && family?.school) {
            setLoading(false)
            setSchool(findTheCorrectSchool(family?.school.toLowerCase()));
        } else if (schools.length > 0 && !family?.school) {
            if(subdomain === 'localhost') {
                setSchool(findTheCorrectSchool('mma'))
            } else {
                for(let i = 0; i < schools.length; i++) {
                    if(schools[i].name.split(' ')[0].toLowerCase() === subdomain) {
                        setSchool(schools[i])
                        break;
                    }
                }
                setLoading(false)
            }
        }
      
    }, [schools, family])

    const getSubdomain = () => window.location.hostname.split('.')[0];

      const initializeTheForm = (family) => {
        let myFamilyObject = {}
        myFamilyObject.students = {}
        myFamilyObject.students = family.students.map((student) => ({
            studentId : student.studentId,
            studentName: student.studentName,
            dob: student.dob,
            experienceLevel: student.experienceLevel,
            instrumentList: student.instrumentList
          }));

        myFamilyObject.primaryEmail = family.primaryEmail
        myFamilyObject.primaryParentName = family.primaryParentName
        myFamilyObject.familyName = family.familyName
        myFamilyObject.primaryCellphone = family.primaryCellphone
        myFamilyObject.addressLine1 = family.address.addressLine1
        myFamilyObject.city = family.address.city
        myFamilyObject.state = family.address.state
        myFamilyObject.zipcode = family.address.zipcode
        reset(myFamilyObject)
      }

      const initializeEmptyForm = () => {
        reset(defaultFormValues)
      }

    const findTheCorrectSchool = (schoolAbbreviation) => schools.find((school) => school.schoolAbbreviation.toLowerCase() === schoolAbbreviation)

    const removeInstrumentFromStudentInFamily = (instrumentId, student, index) => {
        const allValues = getValues(`students.[${index}]`)
        const currentInstrumentList = getValues(`students.[${index}].instrumentList`);
        const updatedInstrumentList = currentInstrumentList.filter((instrument) => instrument.id !== instrumentId)
        update(index, {
            studentId: allValues.studentId,
            studentName: allValues.studentName,
            dob: allValues.dob,
            experienceLevel: allValues.experienceLevel,
            instrumentList: updatedInstrumentList
        });
    }

    const clearInstrumentInputField = (student) => {
        const inputField = document.getElementById(student.studentId);
        if (inputField) {
            inputField.value = '';
        }
    }

    const addInstrumentToStudent = (instrumentId, student, index) => {
        const allValues = getValues(`students.[${index}]`)
        const currentInstrumentList = getValues(`students.[${index}].instrumentList`);
        if(currentInstrumentList.find((instrument) => instrument.id === instrumentId)) {
            clearInstrumentInputField(student)
            return
        } else {
            update(index, {studentId: allValues.studentId,
                studentName: allValues.studentName,
                dob: allValues.dob,
                experienceLevel: allValues.experienceLevel
                ,instrumentList: [
                ...currentInstrumentList,
                instruments.find((instrument) => instrument.id === instrumentId),
              ]});
            clearInstrumentInputField(student)
        }
      };

    const flipBackToPage = (num) => {
        setCurrentAnimationSettings({opacity: 0, transform: 'scale(1.2)', left: '-600px'})
        setRunAnimation(true)
        setTimeout(() => {
            setPage(num)
            setTimeout(() => {
                setRunAnimation(false)
            }, 100)
        }, 400)
    }

    const flipToPage = (num) => {
        if(num === 2) {
            if(watch('primaryParentName') && watch('familyName') && watch('primaryEmail') && watch('primaryCellphone') && watch('addressLine1') && watch('city') && watch('state') && watch('zipcode')) {
                setCurrentAnimationSettings({opacity: 0, transform: 'scale(1.2)', left: '-600px'})
                setRunAnimation(true)
                setTimeout(() => {
                    setPage(2)
                    setTimeout(() => {
                        setRunAnimation(false)
                    }, 100)
                }, 400)
            } else {
                handleSubmit()()
            }
        } else if(num === 3) {
            if(fields.length > 0) {
                for(let i = 0; i < fields.length; i++) {
                    if(!watch(`students[${i}].studentName`) || !watch(`students[${i}].dob`) || !watch(`students[${i}].experienceLevel`) || watch(`students[${i}].instrumentList`).length === 0) {
                        handleSubmit()()
                        return
                    }
                }
                setRunAnimation(true)
                setTimeout(() => {
                    setPage(3)
                    setTimeout(() => {
                        setRunAnimation(false)
                    }, 100)
                }, 400)
                setYouMustAddAStudentWarning(false)
            } else {
                setYouMustAddAStudentWarning(true)
            }
        }
    }

    const checkForStudentFormErrors = (form, index, key) => {
        if (form.errors && form.errors.students && form.errors.students[index] && form.errors.students[index][key]) {
            return true;
        }
        return false; // Return false if any of the properties are undefined
    };

    const addMoreInfoToStudents = (students) => {
        let updatedStudents = students
        for(let i = 0; i < updatedStudents.length; i++) {
            updatedStudents[i].lessonsLength = 30
            updatedStudents[i].lessonRate = 45
            updatedStudents[i].allRates = {
                15: 24,
                30: 47,
                45: 62,
                60: 77
            }
            updatedStudents[i].studentStatus = "Being Onboarded"
            updatedStudents[i].studentNotes = ''
        }
        return updatedStudents
    }


    const submitCompletedForm = (data) => {
        setLoading(true)
        let updatedData = data
        updatedData.initialAvailability = weeklyAvailability
        updatedData.students = addMoreInfoToStudents(updatedData.students)
        updatedData.referral = data.reference
        if(hasFamilyId) {
            updatedData.familyId = familyId
            axios.put(`${baseUrl}/complete-new-student-form`, updatedData)
            .then((response) => {
                if(response.data.message === 'success') {
                    setLoading(false)
                    setFamily(prev => ({...prev, needsToFillOutNewStudentForm: false}))
                }
            })
            .catch((error) => {
                console.log(error)
            })
        } else {
            updatedData.familyId = Math.random().toString(16).slice(2)
            updatedData.school = school.schoolAbbreviation
            axios.post(`${baseUrl}/complete-new-student-form-from-scratch`, updatedData)
            .then((response) => {
                if(response.data.message === 'success') {
                    setLoading(false)
                    setFamily(prev => ({...prev, needsToFillOutNewStudentForm: false, familyId: updatedData.familyId, students: updatedData.students}))
                }
            })
            .catch((error) => {
                console.log(error)
            })
        }
    }
    let animationInSettings = {
        opacity: 1,
        transform: 'scale(1)',
        left: '0px'
    }
    const openDayOfTheWeekStyles = {
        border: '1px solid #E2E8F0', 
        borderRadius: '5px',
        backgroundColor: '#fff'
    }

    const closedEmptyDayOfTheWeekStyles = {
        border: '1px solid #E2E8F0', 
        backgroundColor: '#fff'
    }

    const closedFilledDayOfTheWeekStyles = {
        border: '1px solid green',
        backgroundColor: 'rgba(1, 128, 0, 0.1)',
        color: 'green'
    }

    const focusOnInputBelow = (id) => {
        document.getElementById(id).focus()
    }

    const isDateValid = (value) => {
        const date = new Date(value);
        const currentDate = new Date();
        const minDate = new Date();
        minDate.setFullYear(currentDate.getFullYear() - 100); // Limit age to 100 years
    
        return !isNaN(date.getTime()) && date <= currentDate && date >= minDate;
      };
    

    const renderStudentInputs = () => {
        return fields.map((data, index) => (
          <div key={data.id} className='auto-fill-new-student-form__page__input-wrapper__each-student-wrapper' id={`auto-fill-new-student-form__page__input-wrapper__each-student-wrapper-${data.id}`}>
            <div onClick={() => remove(index)} className='auto-fill-new-student-form__remove-the-student-x'><HiX color='gray'/></div>
              <div key={data.id} className='auto-fill-new-student-form__page__each-input'>
              <div>
                  <div className={`rounded-md px-3 pb-1.5 pt-1.5 shadow-sm ring-1 ring-inset ring-gray-300 ${checkForStudentFormErrors(formState, index, 'studentName') ? 'ring-red-600' : 'ring-gray-300'} focus-within:ring-2 focus-within:ring-indigo-600`}>
                      <label htmlFor="name" onClick={() => focusOnInputBelow(`student-name-${index}`)} className="block text-xs font-medium text-slate-800">
                        Student's Name
                      </label>
                      <input
                      id={`student-name-${index}`}
                      key={data.id}
                        {...register(`students.${index}.studentName`, {
                            required: {
                                value: true,
                                message: 'Student name is required'
                            },
                              pattern: {}
                          })} 
                        type="text"
                        name={`students.${index}.studentName`}
                        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                        placeholder='Who will be taking lessons?'
                      />
                  </div>
                  <p className='auto-fill-new-student-form__page__each-input__error-message'>{checkForStudentFormErrors(formState, index, 'studentName') && formState.errors.students[index].studentName?.message}</p>
              </div>
              </div>

              <div className='auto-fill-new-student-form__page__each-input each-input-shorter-width'>
  <div className={`rounded-md px-3 pb-1.5 pt-1.5 shadow-sm ring-1 ring-inset ring-gray-300 ${checkForStudentFormErrors(formState, index, 'dob') ? 'ring-red-600' : 'ring-gray-300'} focus-within:ring-2 focus-within:ring-indigo-600`}>
    <label htmlFor="name" onClick={() => focusOnInputBelow(`student-dob-${index}`)} className="block text-xs font-medium text-slate-800">
      Date of Birth
    </label>
    <Controller
      name={`students.${index}.dob`}
      control={control}
      rules={{
        validate: {
            isDateValid(value) {
                return isDateValid(value) || 'Invalid date';
              }
            },
        required: "Student's birthday is required",
        pattern: {
          value: /\d{2}\/\d{2}\/\d{4}/,
          message: 'Invalid date format (mm/dd/yyyy)',
        },
      }}
      render={({ field }) => (
        <InputMask
          className='my-mask-input'
          mask="99/99/9999"
          id={`student-dob-${index}`}
          maskPlaceholder="mm/dd/yyyy"
          alwaysShowMask
          placeholder="Student's birthday (mm/dd/yyyy)"
          {...field}
        >
          {(inputProps) => <input {...inputProps} />}
        </InputMask>
      )}
    />
  </div>
  <p className='auto-fill-new-student-form__page__each-input__error-message'>{checkForStudentFormErrors(formState, index, 'dob') && formState.errors.students[index].dob?.message}</p>
</div>

                    <div className='auto-fill-new-student-form__page__each-input'>
                        <select id={data.studentId} className='auto-fill-new-student-form__select-with-label__actual-select' name="selectInput1"  onChange={(e) => addInstrumentToStudent(e.target.value, data, index)}>
                            <option value="">{data.instrumentList?.length > 0 ? 'Add another instrument' : 'Choose an instrument'}</option>
                            {instruments.map((instrument) => (
                                <option key={instrument.id} value={instrument.id}>{instrument.name}</option>
                            ))}
                        </select>
                        {data.instrumentList?.length > 0 ? (
                            <div>
                                {data.instrumentList?.map((instrument) => (
                                    <InstrumentChip key={instrument.id} instrument={instrument} onClick={() => removeInstrumentFromStudentInFamily(instrument.id, data, index)} />
                                ))}
                            </div>
                        )
                        :
                            <p className='auto-fill-new-student-form__page__each-input__error-message'>Please select an instrument</p>
                        }
                    </div>
                    <div className='auto-fill-new-student-form__page__each-input'>
                        <select key={data.id} className='auto-fill-new-student-form__select-with-label__actual-select' name={`students.${index}.experienceLevel`} style={checkForStudentFormErrors(formState, index, 'experienceLevel') ? {border: '1px solid red'} : {border: '1px solid rgb(200, 200, 200)'}} {...register(`students.${index}.experienceLevel`, {required: {value: true, message: 'Please choose an experience level.'}})}>
                            <option value=''>Student's experience level</option>
                            <option value="no experience">First Time</option>
                            <option value="1 year">1 year</option>
                            <option value="2 years">2 years</option>
                            <option value="+2 years">+2 years</option>
                        </select>
                        <p className='auto-fill-new-student-form__page__each-input__error-message'>{checkForStudentFormErrors(formState, index, 'experienceLevel') && formState.errors.students[index].experienceLevel?.message}</p>
                    </div>
          </div>
        ));
      };
      




      //------------------------RETURN------------------------//




      if((family?.familyId && loading) || loading) {
        return (
            <div className='auto-fill-new-student-form__loading-wrapper'>
                <div className='auto-fill-new-student-form__loading-text'>Loading...</div>
            </div>
        )
      } else if(family.needsToFillOutNewStudentForm || !family.familyId) {
        return (
            <div className='auto-fill-new-student-form'>
                <img className='auto-fill-new-student-form__background-image' alt='back' src={`/${school?.schoolAbbreviation ? school?.schoolAbbreviation.toUpperCase() : 'MMA'}.jpg`} />
                {school?.name && 
                    <div className='auto-fill-new-student-form__logo-label'>
                        <div className='auto-fill-new-student-form__whole-logo-label__wrapper'>
                            <div className='auto-fill-new-student-form__logo-label__text-wrapper'>
                                <div className='auto-fill-new-student-form__logo-label__school-name'>{school?.name.toUpperCase()}</div>
                                <div className='auto-fill-new-student-form__logo-label__subtitle'>New Student Form</div>
                            </div>
                            <img className='auto-fill-new-student-form__logo-label__logo' alt='school-logo' src={school?.logoUrl} />
                        </div>
                    </div>
                }
                <form onSubmit={handleSubmit((data) => {submitCompletedForm(data)})}>
                    <div className='auto-fill-new-student-form__page' style={runAnimation ? currentAnimationSettings : animationInSettings}>
                        <div className='wide-form-stepper-wrapper'>
                            <FormStepper step={page} />
                        </div>
                        {page === 1 && (
                            <div className='auto-fill-new-student-form__page__form-area'>
                                <div className='auto-fill-new-student-form__page__title'>Contact Information</div>
                                <div className='auto-fill-new-student-form__page__subtitle'>Please share the following information about you (main contact) and the address where lessons will be taking place. Feel free to update any pre-filled info if necessary. </div>
                                <div className='auto-fill-new-student-form__page__input-wrapper'>
                                    {theInputsPage1.map((input) => (
                                        <div className='auto-fill-new-student-form__page__each-input' key={input.registerName}>
                                            <div className={`rounded-md px-3 pb-1.5 pt-1.5 shadow-sm ring-1 ${formState.errors[input.registerName] ? 'ring-red-600' : 'border-0'} ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-indigo-600`}>
                                                <label htmlFor="name" onClick={() => focusOnInputBelow(input.label)} className="block text-xs font-medium text-slate-800">
                                                  {input.label}
                                                </label>
                                                {input.registerName === 'primaryCellphone' ? 
                                                (
                                                  <Controller
                                                  name={input.registerName}
                                                  control={control}
                                                  rules={{
                                                    required: input.required,
                                                    pattern: input.pattern
                                                  }}
                                                  render={({ field }) => (
                                                    <InputMask
                                                      className='my-mask-input'
                                                      mask="(999) 999-9999"
                                                      id={input.label}
                                                      maskPlaceholder="(###) ###-####"
                                                      alwaysShowMask
                                                      placeholder="Your Phone #"
                                                      {...field}
                                                    >
                                                      {(inputProps) => <input  {...inputProps} />}
                                                    </InputMask>
                                                  )}
                                                />
                                            ) : (
                                                <input
                                                {...register(input.registerName, {
                                                    required: input.required,
                                                      pattern: input.pattern
                                                  })} 
                                                type="text"
                                                name={input.registerName}
                                                id={input.label}
                                                className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                                placeholder={input.placeholder}
                                              />)}
                                            </div>
                                            <p className='auto-fill-new-student-form__page__each-input__error-message'>{formState.errors[input.registerName]?.message}</p>
                                        </div>
                                    ))}
                                    <div className='auto-fill-new-student-form__page__btn-wrapper one-button-wrapper'>
                                        <PrimaryButtonLarge text='Next' color={{background: 'bg-amber-500', text: 'text-white'}} action={() => flipToPage(2)} />
                                    </div>
                                </div>
                            </div>
                         )}
                        {page === 2 && (
                            <div className='auto-fill-new-student-form__page__form-area'>
                                <div className='auto-fill-new-student-form__page__title'>Student Details</div>
                                <div className='auto-fill-new-student-form__page__subtitle'>Please share the following information about the students who will be taking lessons. </div>
                                    <div className='auto-fill-new-student-form__page__input-wrapper__column'>
                                    {renderStudentInputs()}
                                    <div className='auto-fill-new-student-form__page__add-student__wrapper'>
                                        {fields.length > 0 ? <div className='auto-fill-new-student-form__page__add-student' onClick={() => append(defaultFormValues.students)}>+ Add a student</div> : 
                                        <div className='auto-fill-new-student-form__big-add-btn-wrapper'>
                                            <div className='auto-fill-new-student-form__page__add-student-center' onClick={() => append(defaultFormValues.students)}>+ Add a student</div>
                                            {youMustAddAStudentWarning && <p className='auto-fill-new-student-form__page__each-input__error-message__large'>You must add a student</p>}
                                        </div>
                                        }
                                    </div>
                                    <div className='auto-fill-new-student-form__page__btn-wrapper'>
                                        <PrimaryButtonLarge text='Back' color={{background: 'bg-white', text: 'text-gray-800', border: 'border-gray-500'}} action={() => flipBackToPage(1)} />
                                        <PrimaryButtonLarge text='Next' color={{background: 'bg-amber-500', text: 'text-white'}} action={() => flipToPage(3)} />
                                    </div>
                                </div>
                            </div>
                         )}
                        {page === 3 && (
                         <div className='auto-fill-new-student-form__page__form-area'>
                            <div className='auto-fill-new-student-form__page__title'>Availability</div>
                            <div className='auto-fill-new-student-form__page__subtitle'>Please select what days work for you.</div>
                            <div>
                                <div>{daysOfWeek.map((date) => (
                                    <div style={openDate === format(date, 'EEEE') ? openDayOfTheWeekStyles : {border: 'none'}}>
                                        <div className='auto-fill-new-student-form__day-availability-btn' style={openDate === format(date, 'EEEE') ? {border: 'none'} : (weeklyAvailability[format(date, 'EEEE')]['Morning'] || weeklyAvailability[format(date, 'EEEE')]['Afternoon'] || weeklyAvailability[format(date, 'EEEE')]['Evening'] ? closedFilledDayOfTheWeekStyles : closedEmptyDayOfTheWeekStyles)} onClick={() => setOpenDate(openDate === format(date, 'EEEE') ? '' : format(date, 'EEEE'))}>
                                            <div className='auto-fill-new-student-form__day-availability-btn__name'>{format(date, 'EEEE')}</div>
                                            <div className='auto-fill-new-student-form__day-times__wrapper'>
                                                {Object.keys(weeklyAvailability[format(date, 'EEEE')]).map((timeOfDay) => weeklyAvailability[format(date, 'EEEE')][timeOfDay] && (
                                                    <div className='auto-fill-new-student-form__day-times'>{timeOfDay}s</div>
                                                ))}
                                            </div>
                                            <div className='auto-fill-new-student-form__day-availability-btn__chevron' style={openDate === format(date, 'EEEE') ? {transform: 'rotate(0deg)'} : {transform: 'rotate(180deg)'}}>
                                                <ChevronUpIcon width={20} /> 
                                            </div>
                                        </div>
                                        {
                                            openDate === format(date, 'EEEE') && 
                                            <DayOfTheWeekCheckboxSet 
                                                setWeeklyAvailability={setWeeklyAvailability} 
                                                day={openDate} 
                                                weeklyAvailability={weeklyAvailability} 
                                            />
                                        }
                                    </div>
                                ))}
                                </div>
                            <div className='auto-fill-new-student-form__page__input-wrapper'>
                                <textarea className='auto-fill-new-student-form__page__text-area' style={formState.errors['availability'] ? {border: '1px solid red'} : {border: '1px solid rgb(200, 200, 200)'}} placeholder='Any other notes about your availability?' {...register('availability', {required: false})} />
                                </div>
                                <p className='auto-fill-new-student-form__page__each-input__error-message'>{formState.errors.availability?.message}</p>
                                <div className='auto-fill-new-student-form__page__input-wrapper'>                                
                                    <div className='auto-fill-new-student-form__page__each-input'>
                                            <select className='auto-fill-new-student-form__select-with-label__actual-select' {...register('hearOfUs', {required: {value: true, message: 'Please let us know how you heard about us'}})}>
                                                       <option value="">How did you find us?</option>
                                                       <option value="google">Google</option>
                                                       <option value="lessons">Lessons.com</option>
                                                       <option value="facebook">Facebook</option>
                                                       {/* <option value="craigslist">Craigslist</option> */}
                                                       <option value="instagram">Instagram</option>
                                                       <option value="referral">Referral</option>
                                            </select>
                                            <p className='auto-fill-new-student-form__page__each-input__error-message'>{formState.errors.hearOfUs?.message}</p>
                                    </div>
                                    <div className='auto-fill-new-student-form__page__each-input'>
                                        {watch('hearOfUs') === 'referral' && 
                                           <div className="rounded-md px-3 pb-1.5 pt-1.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-indigo-600">
                                           <label htmlFor="name" className="block text-xs font-medium text-slate-800">Reference</label>
                                               <input
                                               {...register('reference', {required: {value: true, message: 'Please let us know who referred you'}})}
                                                 type="text"
                                                 name='reference'
                                                 id='reference'
                                                 className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                                 placeholder="Who referred you?"
                                               />
                                           </div>
                                       }
                                          <p className='auto-fill-new-student-form__page__each-input__error-message'>{formState.errors.reference?.message}</p>
                                     </div>
                                </div>
                                   <div className='auto-fill-new-student-form__page__btn-wrapper'>
                                      <PrimaryButtonLarge text='Back' color={{background: 'bg-white', text: 'text-gray-800', border: 'border-gray-500'}} action={() => flipBackToPage(2)} />
                                       <>
                                           <button
                                             type="submit"
                                             className={`rounded-md bg-amber-500 px-3 py-2 text-sm font-semibold cursor-pointer border-none text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                                           >
                                             Get Started!
                                           </button>
                                       </>
                                   </div>
                            </div>

                        </div>
                        )}
                    </div>
                </form>
                <div className='mobile-form-stepper-wrapper'>
                    <FormStepper step={page} />
                </div>
            </div>
        )
      } else {
            return <ConfirmationPage family={family} school={school} />
      }

}
export default AutoFillNewStudentForm;
